var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDastbahamchist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    viewBox: "191.4 320.48 213.83 200.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.4;fill:#FE4800;enable-background:new    ;}\n\t.st2{fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#263238;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10.0002;}\n\t.st4{fill:#FE4800;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:#92E3A9;}\n\t.st7{fill:#BFBFBF;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hand_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404,321.7v37.4c0,0-85.4,28.4-102.7,36.8s-35.8,25.9-35.8,25.9c-6.2,6.4-29,11.7-27.9,5.8     c0.4-2.2,0.4-4.5,0.1-6.5c-0.4-3.4-1.2-5.9-1.2-5.9c-2,3.8-6.4,8-6.4,8c0,4.4-2.7,11.7-2.7,11.7l-1,14.2     c4.5,8.2,0.5,11.5-1.2,11.3s-3.7-3.2-3.7-3.2l-2.6,0.4c0,0-3.1,6.4-5.5,6.6s-3.8-3.3-3.8-3.3s-1.3,2.4-4.4,1     c-0.7-0.3-1.2-1.1-1.8-2.1c-1.9-3.9-3-11.5-3.3-14.3c-0.4-3.5-0.9-19.9-0.9-21.9s11.1-19,14.4-24.8s5.8-12.8,10.2-15.3     c4.4-2.4,9.3-0.5,23.7-1.3c14.4-0.9,26.8-3.8,33.3-6.2c6.5-2.4,8.1-5.8,17.6-8C307.9,365.6,403.3,321.9,404,321.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.5,413.8c-0.2,1.6-0.9,4.2-1.8,7.2c-0.4-3.4-1.2-5.9-1.2-5.9c-2,3.8-6.4,8-6.4,8     c0,4.4-2.7,11.7-2.7,11.7l-1,14.2c4.5,8.2,0.5,11.5-1.2,11.3s-3.7-3.2-3.7-3.2l-2.6,0.4c0,0-3.1,6.4-5.5,6.6s-3.8-3.3-3.8-3.3     s-1.3,2.4-4.4,1c-0.7-0.3-1.2-1.1-1.8-2.1c1.1,0.5,2.4,0,3.7-3.3c2.8-7.5-1.3-13.5-1.3-13.5s4.6-9.8,4.4-12.2     c-0.2-2.4-2.7-4.7-1.8-6.3c0.9-1.6,3.2,1.3,5-0.6s8.4-12.2,8.1-13.4c-0.3-1.2,1.7-1.1,2.7-2s0.8-5.3,2.1-4.7     c1.4,0.5,2.8,1.3,2.8,1.3s0.3-2.5,0-3s4.8,4.7,6.3,4.9C237,407.1,240.1,408.5,239.5,413.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M404,321.7c-0.7,0.2-96,43.9-105.6,46.1c-9.5,2.2-11.1,5.5-17.6,8c-6.5,2.4-18.9,5.3-33.3,6.2      c-14.4,0.9-19.3-1.1-23.7,1.3c-4.4,2.4-6.9,9.5-10.2,15.3c-3.3,5.8-14.4,22.8-14.4,24.8s0.4,18.4,0.9,21.9      c0.4,3.5,2,15,5.1,16.4c3.1,1.5,4.4-1,4.4-1s1.4,3.5,3.8,3.3s5.5-6.6,5.5-6.6l2.6-0.3c0,0,1.9,3,3.7,3.2s5.7-3.1,1.2-11.3      l1-14.2c0,0,2.7-7.3,2.7-11.7c0,0,4.4-4.2,6.4-8c0,0,2.2,6.5,1.1,12.4s21.7,0.6,27.9-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.7,460.7c0,0,3.7-10,0-16.2c0,0,1.1-2,1.6-4.6c0.5-2.7,1.7-10.1,1.3-11.3c-0.3-1.2,0.8-2.5,0.8-2.5      s2-1.8,4.1-5c2.2-3.2,5.1-9,5.1-9s2.2-0.7,4.8-3.8c0,0,2.8-0.8,4.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.2,409.1c0,0,1.5,4.8,0,8.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M236.5,415.2c0,0-0.6-3.6-1.9-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.7,412.2c0,0,3.2,4.1,10,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M227.7,417.5c0,0-4.3,8.3-6,10.1l-1,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.3,427.6c0,0,2.2,1.3,5.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.1,423.1c0,0-3.4,3-4.8,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225.2,403.8c0,0,2.3,2,2.3,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.6,400.4c-0.2,0.5,2.3,4.6,4.1,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208.5,425.5c0,0,2.5,1.7,5,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.1,444.1c0,0,2.8,0.2,3.3-1.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.6,451.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9954 -9.596761e-02 9.596761e-02 0.9954 -43.4845 22.6474)",
    className: "st3",
    cx: 213.7,
    cy: 463.4,
    rx: 7.9,
    ry: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M214.8,472.9c-0.9-2-2.6-3.7-4.8-4.5c-4.4-1.7-9.4,0.6-11.1,5l-5.7,15.1c-1.7,4.5,0.6,9.4,5,11.1      c4.5,1.7,9.4-0.6,11.1-5l5.7-15.1C215.8,477.2,215.7,474.9,214.8,472.9z M208.3,472.8c-0.7-0.3-1.1-1.1-0.8-1.9      c0.3-0.8,1.1-1.1,1.9-0.8c0.8,0.3,1.1,1.1,0.8,1.9C209.9,472.7,209.1,473.1,208.3,472.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M212.7,478.6l-5.7,15.1c-1.2,3.2-4.7,4.8-7.9,3.6c-3.2-1.2-4.8-4.7-3.6-7.9l5.7-15.1      c0.5-1.4,1.5-2.4,2.7-3.1c0.6,1.6,1.9,3,3.7,3.7c1.8,0.7,3.7,0.5,5.2-0.3C213.2,475.8,213.2,477.2,212.7,478.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202.1,479l1.3-3.3l1,0.4l-0.4,1.1l5.9,2.3l-0.4,1.1l-5.9-2.3l-0.4,1.1L202.1,479z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214.1,469.5l-11.7,5.5c-1,0.5-1.5,1.7-1,2.7l7.2,15.3c0.5,1,1.7,1.5,2.7,1l3.4-1.6l12.2,26.1      c0.3,0.7,1.2,1,1.9,0.7l2.3-1.1c0.7-0.3,1-1.2,0.7-1.9l-12.2-26.1l3.4-1.6c1-0.5,1.5-1.7,1-2.7l-7.2-15.3      C216.3,469.4,215.1,469,214.1,469.5z M216.1,472.7c0.4,0.9,0,1.9-0.8,2.3l-0.4,0.2c-0.9,0.4-1.9,0-2.3-0.8l-0.2-0.4      c-0.4-0.9,0-1.9,0.8-2.3l0.4-0.2c0.9-0.4,1.9,0,2.3,0.8L216.1,472.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "229,516.7 217,491.1 218.3,490.5     "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.5,462.6c0.5,5.5-2.6,10.3-6.9,10.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404,330.3v43.1c0,0-1.2,0.3-3.4,0.9l0,0c-16.3,4.2-85.9,22.3-91.5,24.4c-6.4,2.4-12.8,6.2-15,6.6     c-2.2,0.5-13.7,13.5-17.3,16.8s-12.2,7.1-22.1,9.7s-19.2,9.7-21.7,12c-2.4,2.2-14.8,19-17.7,17.7c-2.3-1-5.5-1.7-5.6-6.4     c0-1.3,0.2-2.9,0.7-4.8c2.4-9.3,7.7-16.6,12.8-18.4s17.3-17.5,17.7-21.5L404,330.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.6,374.4c-16.3,4.2-85.9,22.3-91.5,24.4c-6.4,2.4-12.8,6.2-15,6.6c-2.2,0.5-13.7,13.5-17.3,16.8     s-12.2,7.1-22.1,9.7s-19.2,9.7-21.7,12c-2.4,2.2-14.8,19-17.7,17.7c-2.3-1-5.5-1.7-5.6-6.4c1.4,2.3,3.7,4.9,4.6,3.9     c0,0-2.7-0.2,0-6.7c2.7-6.5,4-9.7,7.3-7.3c3.3,2.4,7.1,3.2,8.5-1.6c1.3-4.8,1.8-2.6,7.8-6.5c6-4,12.3-10.6,14.1-10.4     s15.6-1.1,19.8-3.4c4.2-2.2,16-15.5,16.3-19.4c0.3-3.8,15.1-9.4,18.8-11.5c3.7-2.2,18.1-4.9,23.7-6.1c5.5-1.2-8.3,3.9-12.5,6.8     s35-9.9,45.3-11.9C373.4,379,399.5,374.5,400.6,374.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M404,373.5c0,0-88.5,22.9-94.9,25.3s-12.8,6.2-15,6.6s-13.7,13.5-17.3,16.8s-12.2,7.1-22.1,9.7     c-10,2.7-19.3,9.7-21.7,11.9c-2.4,2.2-14.8,19-17.7,17.7c-2.9-1.3-7.3-2-4.9-11.3s7.7-16.6,12.8-18.4s17.3-17.5,17.7-21.5"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDastbahamchist);
export default __webpack_public_path__ + "static/media/dastbahamchist.b7b681c484f4e9c5cce48614e92635a3.svg";
export { ForwardRef as ReactComponent };